<template>
<div>
    <!-- modal -->
    <b-modal id="previewEInvoiceFormModal" centered size="xl" no-close-on-backdrop ref="previewEInvoiceFormModal" :title=" $t('previewEInvoice.preview_e_invoice')" hide-footer>
        <h5 v-if="warningMessage" style="color: red;">{{ warningMessage }}</h5>
        <div class="custom-search mb-1">
                <b-row>
                    <b-col class="col-lg-6 mt-1">
                        <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" id="invoiceDate" v-model="eInvoiceDate"  @input="updateInvoiceDate()" :defaultDate="null" reset-button class="mb-1" size="sm" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-col>
                    <b-col class="col-6  d-flex justify-content-end">
                        <b-button  variant="outline-warning" class="ml-1" size="sm" v-b-tooltip.html :title="$t('previewEInvoice.send_gib')" @click="CreateEArchiveFaturaForSend()">
                            <feather-icon icon="CompassIcon" size="10" class="align-middle" />
                        </b-button>
                    </b-col>
                </b-row>
        </div>
        <div v-html="html" >
        </div>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getCreateInvoiceList: {
            type: Function
        }
    },   
    data() {
        return {
            id:0,
            html:'',
            eInvoiceDate: null,
            warningMessage: ''
        }
    },
    methods: {
        CreateEArchiveFaturaForSend() {
            let data = {
                companyId: 1,
                invoiceId: this.id
            }
            let controller = {
                name: 'NesEArchiveFatura',
                actionName: 'CreateEArchiveFaturaForSend'
            }
            let payload = {
                data: data,
                controller: controller
            }
           
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {    
                    data = {
                        isDirectSend : true,
                        autoSaveCompany : false,
                        sourceApp : "STOCKAPI",
                        sourceAppRecordId : "1",
                        previewType : "Html",
                        file : response.data.xml,
                        uUID : response.data.eInvoiceUUID,
                        iD : response.data.eInvoiceId,
                        invoiceId : this.id
                    }
                    controller = {
                        name: 'NesEArchiveFatura',
                        actionName: 'UploadEArchiveInvoice'
                    }
                    payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {                       
                            this.getCreateInvoiceList()
                            this.$CustomAlert("Fatura GİB'e iletildi","success")              
                        } else {
                            this.$WarningAlert("Hata Oluştu")
                        }
                        loader.hide()
                    })
                } 
                else
                {
                    this.$WarningAlert("Hata Oluştu")
                    loader.hide()
                }
            })
        },
        updateInvoiceDate(){
            const data = {
                id: this.id,
                einvoiceDate: this.eInvoiceDate
            }

            const controller = {
                name: 'Invoice',
                actionName: 'UpdateEInvoiceDate'
            }
            const payload = {
                data: data,
                controller: controller
            }
           let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.showInfo(this.id)
                    this.getCreateInvoiceList()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        showInfo(id) {
            this.warningMessage = ''
            this.$refs['previewEInvoiceFormModal'].show()
            this.id = id
            
            let data = {
                id : this.id
            }
            let controller = {
                name: 'Invoice',
                actionName: 'PreviewEInvoiceInfo'
            }
            let payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.eInvoiceDate = response.data.eInvoice.eInvoiceDate
                    const today = new Date();
                    const sevenDaysAgo = new Date();
                    sevenDaysAgo.setDate(today.getDate()-7);
                    if(Date.parse(this.eInvoiceDate) < sevenDaysAgo){
                        this.warningMessage = this.$t('previewEInvoice.one_week_ago_warning');
                    } 
                    data = {
                        companyId: 1,
                        invoiceId: this.id
                    }
                    controller = {
                        name: 'NesEArchiveFatura',
                        actionName: 'CreateEArchiveFaturaForSend'
                    }

                    payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            data = {
                                file : response.data.xml
                            }
                            controller = {
                                name: 'NesEArchiveFatura',
                                actionName: 'PreviewEArchiveFatura'
                            }
                            payload = {
                                data: data,
                                controller: controller
                            }
                            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                                if (response.data.resultStatus == true) {
                                    const bytes = Uint8Array.from(atob(response.data.fileAsBase64), c => c.charCodeAt(0));
                                    this.html = new TextDecoder('utf-8').decode(bytes);
                                } else {
                                    this.$WarningAlert("Hata Oluştu")                                    
                                }
                                loader.hide()
                            })
                        } else {
                            this.$WarningAlert("Hata Oluştu")
                            loader.hide()
                        }
                    })                    
                } else {
                    this.$WarningAlert("Hata Oluştu")
                    loader.hide()
                }
            })
        }

    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
.agentInput {
    max-width: 87em !important;
    width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}
</style>
